import { FC } from 'react'
import { Select } from 'entities/Select'
import { MealContainer } from './styled'
import { GridDiv } from 'entities/GridDiv'
import { useConfigStore } from 'shared/store/configSlice'

import {
  bookingDinnerFromTimeValues,
  bookingDinnerToTimeValues,
  bookingLunchFromTimeValues,
  bookingLunchToTimeValues
} from './types'

export const Meal: FC<MealProps> = ({ mealType, dayValue }) => {
  const bookingTimeIntervals = useConfigStore().config?.tableReservationConfig?.bookingTimeIntervals
  const updateTableReservationConfig = useConfigStore().updateTableReservationConfig

  const updateIntervals = (valueToSet: string) => {
    updateTableReservationConfig({ bookingTimeIntervals: valueToSet })
  }

  const getBookingTimeList = (values: number[]) => {
    return values?.map(value => ({
      value: `${String(value).padStart(2, '0')}:00`,
      label: `${String(value).padStart(2, '0')}:00`
    }))
  }

  const updateScheduleHandler = (value = '') => {
    let parsedIntervals = JSON.parse(bookingTimeIntervals || '{}')
    const [dayName, dayType, intervalType, intervalValue] = value.split('-')
    if (!parsedIntervals[dayName]) parsedIntervals[dayName] = {}
    if (!parsedIntervals[dayName][dayType]) parsedIntervals[dayName][dayType] = {}
    parsedIntervals[dayName][dayType][intervalType] = intervalValue
    parsedIntervals = JSON.stringify(parsedIntervals)
    updateIntervals(parsedIntervals)
  }

  return (
    <MealContainer>
      <GridDiv $gc='1 / -1'>
        <p>{mealType === 'lunch' ? 'Lunch' : 'Dinner'}</p>
      </GridDiv>
      <Select
        key={`${dayValue}_${mealType}_from`}
        label={'Lunch from'}
        options={getBookingTimeList(
          mealType === 'lunch' ? bookingLunchFromTimeValues : bookingDinnerFromTimeValues
        )}
        value={JSON.parse(bookingTimeIntervals || '{}')?.[dayValue]?.[mealType]?.['from'] || ''}
        onChange={(value: string | number) =>
          updateScheduleHandler(`${dayValue}-${mealType}-from-${value}`)
        }
      />
      <Select
        key={`${dayValue}_${mealType}_to`}
        label={'Lunch to'}
        options={getBookingTimeList(
          mealType === 'lunch' ? bookingLunchToTimeValues : bookingDinnerToTimeValues
        )}
        value={JSON.parse(bookingTimeIntervals || '{}')?.[dayValue]?.[mealType]?.['to'] || ''}
        onChange={(value: string | number) =>
          updateScheduleHandler(`${dayValue}-${mealType}-to-${value}`)
        }
      />
    </MealContainer>
  )
}

type MealProps = {
  mealType: 'lunch' | 'dinner'
  dayValue: number
}
